import { render, staticRenderFns } from "./CheckList.vue?vue&type=template&id=490cb50e&scoped=true&"
import script from "./CheckList.vue?vue&type=script&lang=js&"
export * from "./CheckList.vue?vue&type=script&lang=js&"
import style0 from "./CheckList.vue?vue&type=style&index=0&id=490cb50e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "490cb50e",
  null
  
)

export default component.exports